import React, { Component } from 'react';
import { NumberInput, FormDataConsumer } from 'react-admin';
import { useInput } from 'react-admin';

// eslint-disable-next-line react/prefer-stateless-function
const NumberBetweenInput = ({source, label}) => {
    const { id, field, fieldState } = useInput(source);
    const styles = {
      row: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        justifyContent: 'space-between'
      }
    };
    // eslint-disable-next-line react/prop-types
    // const { resource, source } = this.props;
    return (
        <FormDataConsumer>
          {
            ({ formData, ...rest }) =>
            <span style={styles.row}>
              <NumberInput source={`${source}_min`} label={`Min.`} variant={'outlined'}/>
              &nbsp;
              <NumberInput source={`${source}_max`} label={`Max.`} variant={'outlined'}/>
            </span>
          }
        </FormDataConsumer>

    );
}

NumberBetweenInput.defaultProps = {
  addLabel: true,
  label: 'totalInvestment',
};

export default NumberBetweenInput;
